/* Tiloa Duck — pile de confiance sous le bouton d'achat (gabarit product.canard).
 *
 * Aucune dépendance, aucune requête tant que le visiteur n'a rien demandé.
 * Délégation d'événements sur le document : les blocs re-rendus par
 * l'éditeur de thème restent actifs sans réinitialisation.
 *
 *   .td-fq__btn            accordéon : aria-expanded + .is-open sur .td-fq__item
 *   [data-td-ugc-open]     ouvre le lecteur TILOA du bloc (<dialog>) : vidéo
 *                          480p sous 750 px ou en économie de données, muette
 *                          au départ, commandes à la marque (lecture,
 *                          progression, son), légende et étiquette, vidéo
 *                          précédente / suivante (flèches, clavier, glisser) ;
 *                          une seule vidéo à la fois ; à la fermeture la vidéo
 *                          est arrêtée et retirée, le focus revient à la carte.
 */
(function () {
  'use strict';

  /* Script inclus deux fois (gabarit, application, éditeur) : les écouteurs
     posés deux fois annuleraient chaque ouverture d'accordéon. */
  if (window.tdTrustPret) return;
  window.tdTrustPret = true;

  function sansEchec(fn) {
    return function (e) { try { fn(e); } catch (err) { /* un effet raté ne doit rien casser d'autre */ } };
  }

  /* ---------- Questions essentielles ---------- */
  document.addEventListener('click', sansEchec(function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.td-fq__btn');
    if (!btn) return;
    var item = btn.closest('.td-fq__item');
    var ouvrir = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
    if (item) item.classList.toggle('is-open', ouvrir);
  }));

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Carrousels de cartes d'avis ([data-td-cards]) ---------- */
  function majFleches(track) {
    var racine = track.closest('[data-td-cards]');
    if (!racine) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    var p = racine.querySelector('[data-td-cards-prev]');
    var n = racine.querySelector('[data-td-cards-next]');
    if (p) p.setAttribute('aria-disabled', track.scrollLeft <= 2 ? 'true' : 'false');
    if (n) n.setAttribute('aria-disabled', track.scrollLeft >= max ? 'true' : 'false');
  }
  document.addEventListener('click', sansEchec(function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-td-cards-prev], [data-td-cards-next]');
    if (!btn) return;
    var racine = btn.closest('[data-td-cards]');
    var track = racine && racine.querySelector('[data-td-cards-track]');
    var carte = track && track.querySelector('.td-card');
    if (!track || !carte) return;
    var pas = carte.getBoundingClientRect().width + 14;
    track.scrollBy({ left: btn.hasAttribute('data-td-cards-next') ? pas : -pas, behavior: reduit ? 'auto' : 'smooth' });
  }));
  document.addEventListener('scroll', sansEchec(function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-td-cards-track')) majFleches(t);
  }), true);
  function initFleches() { document.querySelectorAll('[data-td-cards-track]').forEach(majFleches); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFleches); else initFleches();
  window.addEventListener('resize', sansEchec(initFleches), { passive: true });

  /* ---------- Défilement automatique des avis (3 s par carte) ----------
     S'arrête au survol, au toucher, au focus et aux flèches (reprise 6 s plus
     tard), hors écran et onglet caché ; rien si « réduire les animations ». */
  var autoPauses = [];
  function autoDefile(track) {
    if (reduit || track.dataset.tdAuto) return;
    track.dataset.tdAuto = '1';
    var etat = { pause: false, visible: false, reprise: 0 };
    autoPauses.push({ track: track, etat: etat });
    function suivant() {
      if (etat.pause || !etat.visible || document.hidden) return;
      if (track.contains(document.activeElement)) return;
      if (document.querySelector('dialog.tiloa-lb[open], .td-ugc__modal[open]')) return;
      var carte = track.querySelector('.td-card');
      if (!carte) return;
      var pas = carte.getBoundingClientRect().width + 14;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (max <= 0) return;
      if (track.scrollLeft >= max) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: pas, behavior: 'smooth' });
    }
    setInterval(suivant, 3000);
    function arreter() {
      etat.pause = true;
      clearTimeout(etat.reprise);
      etat.reprise = setTimeout(function () { etat.pause = false; }, 6000);
    }
    ['pointerdown', 'touchstart', 'wheel', 'focusin', 'keydown'].forEach(function (ev) { track.addEventListener(ev, arreter, { passive: true }); });
    track.addEventListener('mouseenter', function () { clearTimeout(etat.reprise); etat.pause = true; });
    track.addEventListener('mouseleave', function () { etat.pause = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { etat.visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(track);
    } else {
      etat.visible = true;
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-td-cards-prev], [data-td-cards-next]');
    if (!btn) return;
    var racine = btn.closest('[data-td-cards]');
    var track = racine && racine.querySelector('[data-td-cards-track]');
    autoPauses.forEach(function (a) {
      if (a.track === track) { a.etat.pause = true; clearTimeout(a.etat.reprise); a.etat.reprise = setTimeout(function () { a.etat.pause = false; }, 6000); }
    });
  }, true);
  function initAuto() { document.querySelectorAll('[data-td-cards-track]').forEach(autoDefile); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAuto); else initAuto();

  /* ---------- Vidéos de la grille : lecture muette dès qu'elles sont à l'écran ----------
     Les trois en même temps ; fichier léger (480p), point de départ respecté,
     relance en boucle depuis ce point ; pause hors écran. Rien en mode
     économie de données ni si « réduire les animations ». */
  function videosGrille(racine) {
    if (racine.dataset.tdLive) return;
    racine.dataset.tdLive = '1';
    if (reduit || (navigator.connection && navigator.connection.saveData) || !('IntersectionObserver' in window)) return;
    var cartes = Array.prototype.slice.call(racine.querySelectorAll('[data-td-ugc-open]'));
    function lancer(btn) {
      var v = btn.querySelector('.td-ugc__live');
      if (!v) return;
      if (!v.getAttribute('src')) {
        var src = btn.getAttribute('data-src-mobile') || btn.getAttribute('data-src');
        if (!src) return;
        var mt = /#t=([\d.]+)/.exec(src);
        var depart = mt ? parseFloat(mt[1]) || 0 : 0;
        v.dataset.depart = String(depart);
        v.muted = true;
        v.defaultMuted = true;
        v.addEventListener('loadeddata', function () { v.classList.add('is-live'); });
        v.addEventListener('ended', function () { try { v.currentTime = depart; } catch (err) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); });
        v.preload = 'auto';
        v.src = src;
      }
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    /* Chargement anticipé : les fichiers partent un peu avant que la grille n’arrive à l’écran. */
    function precharger(btn) {
      var v = btn.querySelector('.td-ugc__live');
      if (!v || v.getAttribute('src')) return;
      lancer(btn);
      try { v.pause(); } catch (err) {}
    }
    new IntersectionObserver(function (entrees, obs) {
      if (!entrees[0].isIntersecting) return;
      cartes.forEach(precharger);
      obs.disconnect();
    }, { rootMargin: '700px 0px' }).observe(racine);
    new IntersectionObserver(function (entrees) {
      var visible = entrees[0].isIntersecting;
      cartes.forEach(function (btn) {
        var v = btn.querySelector('.td-ugc__live');
        if (!v) return;
        if (visible) {
          if (!document.querySelector('.td-ugc__modal[open]')) lancer(btn);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.35 }).observe(racine.querySelector('.td-ugc__grid') || racine);
  }
  function initVideos() { document.querySelectorAll('[data-td-ugc]').forEach(videosGrille); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVideos); else initVideos();

  /* ---------- Bandeau de garanties : pause ---------- */
  document.addEventListener('click', sansEchec(function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-td-gar-pause]');
    if (!btn) return;
    var bande = btn.closest('.td-gar');
    var enPause = !bande.classList.contains('is-paused');
    bande.classList.toggle('is-paused', enPause);
    btn.setAttribute('aria-pressed', enPause ? 'true' : 'false');
    btn.setAttribute('aria-label', enPause ? 'Reprendre le défilement' : 'Mettre en pause le défilement');
  }));

  /* ---------- Vidéos en situation ---------- */
  /* actif : { dlg, stage, frame, video, cartes, index, trigger, enPause, bodyPad, depart } */
  var actif = null;

  function source(btn) {
    var mobile = btn.getAttribute('data-src-mobile');
    var hd = btn.getAttribute('data-src');
    var leger = (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ||
      (navigator.connection && navigator.connection.saveData);
    return (leger && mobile) ? mobile : (hd || mobile);
  }

  function horloge(s) {
    s = Math.max(0, Math.floor(s || 0));
    return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2);
  }

  function verrouiller(on) {
    var html = document.documentElement;
    var body = document.body;
    if (on) {
      var barre = window.innerWidth - html.clientWidth;
      actif.bodyPad = body.style.paddingRight;
      html.classList.add('td-ugc-lock');
      if (barre > 0) body.style.paddingRight = barre + 'px';
    } else {
      html.classList.remove('td-ugc-lock');
      body.style.paddingRight = actif ? (actif.bodyPad || '') : '';
    }
  }

  function piegeFallback(e) {
    if (!actif || !actif.dlg.classList.contains('is-fallback')) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); fermer(); return; }
    if (e.key !== 'Tab') return;
    var f = actif.dlg.querySelectorAll('button:not([hidden]), input, [href], [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var premier = f[0];
    var dernier = f[f.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
    else if (!actif.dlg.contains(document.activeElement)) { e.preventDefault(); premier.focus(); }
  }

  function retirerVideo() {
    if (!actif || !actif.video) return;
    var v = actif.video;
    try { v.pause(); } catch (err) {}
    v.removeAttribute('src');
    try { v.load(); } catch (err) {}
    if (v.parentNode) v.parentNode.removeChild(v);
    actif.video = null;
  }

  function nettoyer() {
    if (!actif) return;
    var a = actif;
    retirerVideo();
    a.stage.innerHTML = '';
    a.dlg.classList.remove('is-fallback');
    document.removeEventListener('keydown', piegeFallback, true);
    verrouiller(false);
    /* Les vidéos d'ambiance mises en pause à l'ouverture repartent. */
    if (!reduit) {
      a.enPause.forEach(function (o) {
        if (o.isConnected && o.dataset.tdUserPaused !== '1') {
          var p = o.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }
    actif = null;
    if (a.trigger && a.trigger.isConnected) {
      try { a.trigger.focus({ preventScroll: true }); } catch (err) { a.trigger.focus(); }
    }
  }

  function fermer() {
    if (!actif) return;
    var dlg = actif.dlg;
    /* Fermeture puis nettoyage dans la foulée : l'événement « close », qui
       arrive plus tard, ne retrouvera plus rien à faire. */
    if (typeof dlg.close === 'function' && dlg.open && !dlg.classList.contains('is-fallback')) dlg.close();
    else dlg.removeAttribute('open');
    nettoyer();
  }

  /* --- Commandes du lecteur --- */
  function q(sel) { return actif ? actif.dlg.querySelector(sel) : null; }

  function majLecture() {
    if (!actif || !actif.video) return;
    var v = actif.video;
    var enPause = v.paused || v.ended;
    actif.frame.classList.toggle('is-paused', enPause);
    var b = q('[data-td-vw-play]');
    if (b) b.setAttribute('aria-label', enPause ? 'Lecture' : 'Pause');
  }

  function majSon() {
    if (!actif || !actif.video) return;
    var muet = actif.video.muted;
    var b = q('[data-td-vw-sound]');
    var t = q('[data-td-vw-sound-txt]');
    if (b) {
      b.setAttribute('aria-pressed', muet ? 'false' : 'true');
      b.setAttribute('aria-label', muet ? 'Activer le son' : 'Couper le son');
      b.classList.toggle('is-on', !muet);
    }
    if (t) t.textContent = muet ? 'Son' : 'Son activé';
  }

  function majTemps() {
    if (!actif || !actif.video) return;
    var v = actif.video;
    var d0 = actif.depart || 0;
    var total = (isFinite(v.duration) ? v.duration : 0) - d0;
    var ecoule = Math.max(0, v.currentTime - d0);
    var r = q('[data-td-vw-seek]');
    var t = q('[data-td-vw-time]');
    var part = total > 0 ? Math.min(1, ecoule / total) : 0;
    if (r && !r.dataset.glisse) {
      r.value = String(Math.round(part * 1000));
      r.style.setProperty('--td-p', (part * 100).toFixed(2) + '%');
      r.setAttribute('aria-valuetext', horloge(ecoule) + ' sur ' + horloge(total));
    }
    if (t) t.textContent = horloge(ecoule) + (total > 0 ? ' / ' + horloge(total) : '');
  }

  function basculer() {
    if (!actif || !actif.video) return;
    var v = actif.video;
    if (v.paused || v.ended) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    else v.pause();
  }

  function charger(index) {
    if (!actif) return;
    var n = actif.cartes.length;
    index = ((index % n) + n) % n;
    var btn = actif.cartes[index];
    var src = source(btn);
    if (!src) return;
    retirerVideo();
    actif.index = index;

    var libelle = btn.getAttribute('aria-label') || '';
    var v = document.createElement('video');
    v.className = 'td-ugc__video';
    v.controls = false;
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.preload = 'auto';
    if (libelle) v.setAttribute('aria-label', libelle);
    /* Affiche : on part de la vignette déjà chargée dans la grille (aucun écran
       noir sur réseau lent), puis on passe à la version nette dès qu'elle est
       là, si la vidéo n'a pas encore pris le relais. */
    var affiche = btn.getAttribute('data-poster');
    var vig = btn.querySelector('.td-ugc__poster');
    var vite = (vig && vig.complete && vig.naturalWidth) ? vig.currentSrc : '';
    v.poster = vite || affiche || '';
    if (affiche && vite && vite !== affiche) {
      var hd = new Image();
      hd.onload = function () { if (v.isConnected && v.readyState < 2) v.poster = affiche; };
      hd.src = affiche;
    }
    v.src = src;
    /* Point de départ (#t=…) : la relecture repart de là et la barre ne
       permet pas de revenir avant (passages sans rapport avec la légende). */
    var depart = 0;
    var mt = /#t=([\d.]+)/.exec(src);
    if (mt) depart = parseFloat(mt[1]) || 0;
    actif.depart = depart;
    v.addEventListener('ended', function () { try { v.pause(); v.currentTime = depart; } catch (err) {} majLecture(); });
    if (depart) {
      v.addEventListener('seeking', function () { if (v.currentTime < depart - 0.05) { try { v.currentTime = depart; } catch (err) {} } });
    }
    ['play', 'pause', 'playing'].forEach(function (ev) { v.addEventListener(ev, majLecture); });
    ['timeupdate', 'loadedmetadata', 'durationchange', 'seeked'].forEach(function (ev) { v.addEventListener(ev, majTemps); });
    v.addEventListener('volumechange', majSon);
    v.addEventListener('click', basculer);

    actif.stage.innerHTML = '';
    actif.stage.appendChild(v);
    actif.video = v;
    if (libelle) actif.dlg.setAttribute('aria-label', libelle);

    var cap = q('[data-td-vw-cap]');
    var chip = q('[data-td-vw-chip]');
    var cnt = q('[data-td-vw-count]');
    if (cap) cap.textContent = btn.getAttribute('data-caption') || '';
    if (chip) {
      var tag = btn.getAttribute('data-tag') || '';
      chip.textContent = tag;
      chip.hidden = !tag;
    }
    if (cnt) cnt.textContent = n > 1 ? (index + 1) + ' / ' + n : '';
    ['[data-td-vw-prev]', '[data-td-vw-next]'].forEach(function (s) { var b = q(s); if (b) b.hidden = n < 2; });

    majLecture();
    majSon();
    majTemps();
    var p = v.play();
    if (p && p.catch) p.catch(function () { majLecture(); /* lecture refusée : le bouton lecture reste là */ });
  }

  function brancher(dlg) {
    if (dlg.dataset.tdUgcReady) return;
    dlg.dataset.tdUgcReady = '1';
    /* Échap : « cancel » arrive tout de suite, on ferme et on nettoie sans
       attendre « close » (événement différé). Si le navigateur ferme quand
       même sans « cancel », « close » rattrape le nettoyage. */
    dlg.addEventListener('cancel', sansEchec(function (e) {
      if (!actif || actif.dlg !== dlg) return;
      e.preventDefault();
      fermer();
    }));
    dlg.addEventListener('close', sansEchec(function () { if (actif && actif.dlg === dlg && !dlg.open) nettoyer(); }));
    dlg.addEventListener('click', sansEchec(function (e) {
      if (!actif || actif.dlg !== dlg) return;
      var t = e.target;
      if (t.closest('[data-td-ugc-close]')) { e.preventDefault(); fermer(); return; }
      if (t.closest('[data-td-vw-big]') || t.closest('[data-td-vw-play]')) { basculer(); return; }
      if (t.closest('[data-td-vw-sound]')) { if (actif.video) actif.video.muted = !actif.video.muted; return; }
      if (t.closest('[data-td-vw-prev]')) { charger(actif.index - 1); return; }
      if (t.closest('[data-td-vw-next]')) { charger(actif.index + 1); return; }
      /* Clic sur le fond sombre, hors cadre et hors commandes : on ferme. */
      if (t === dlg || t.classList.contains('td-vw')) { e.preventDefault(); fermer(); }
    }));
    var r = dlg.querySelector('[data-td-vw-seek]');
    if (r) {
      r.addEventListener('input', sansEchec(function () {
        if (!actif || !actif.video) return;
        var v = actif.video;
        r.dataset.glisse = '1';
        var total = (isFinite(v.duration) ? v.duration : 0) - (actif.depart || 0);
        var part = Number(r.value) / 1000;
        r.style.setProperty('--td-p', (part * 100).toFixed(2) + '%');
        if (total > 0) v.currentTime = (actif.depart || 0) + part * total;
      }));
      r.addEventListener('change', function () { delete r.dataset.glisse; majTemps(); });
    }
    dlg.addEventListener('keydown', sansEchec(function (e) {
      if (!actif || actif.dlg !== dlg) return;
      var surCurseur = e.target && e.target.matches && e.target.matches('input[type="range"]');
      var surBouton = e.target && e.target.closest && e.target.closest('button');
      if (!surCurseur && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        charger(actif.index + (e.key === 'ArrowRight' ? 1 : -1));
      } else if (!surCurseur && !surBouton && (e.key === ' ' || e.key === 'k')) {
        e.preventDefault();
        basculer();
      } else if (e.key === 'm' && !surCurseur) {
        if (actif.video) actif.video.muted = !actif.video.muted;
      }
    }));
    /* Glisser horizontalement sur le cadre : vidéo suivante / précédente. */
    var cadre = dlg.querySelector('[data-td-vw-frame]');
    if (cadre) {
      var x0 = null, y0 = null;
      cadre.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      cadre.addEventListener('touchend', sansEchec(function (e) {
        if (x0 === null || !actif) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && !(e.target.closest && e.target.closest('.td-vw__bar'))) {
          charger(actif.index + (dx < 0 ? 1 : -1));
        }
        x0 = null;
      }), { passive: true });
    }
  }

  function ouvrir(btn) {
    var racine = btn.closest('[data-td-ugc]');
    var dlg = racine && racine.querySelector('[data-td-ugc-modal]');
    var stage = dlg && dlg.querySelector('[data-td-ugc-stage]');
    var frame = dlg && dlg.querySelector('[data-td-vw-frame]');
    if (!dlg || !stage || !frame || !source(btn)) return;
    if (actif) fermer();
    brancher(dlg);

    var cartes = Array.prototype.slice.call(racine.querySelectorAll('[data-td-ugc-open]'));

    /* Une seule vidéo à la fois : celles qui jouaient sur la page s'arrêtent. */
    var enPause = [];
    document.querySelectorAll('video').forEach(function (o) {
      if (!o.paused) { o.pause(); enPause.push(o); }
    });

    actif = { dlg: dlg, stage: stage, frame: frame, video: null, cartes: cartes, index: 0, trigger: btn, enPause: enPause, bodyPad: '', depart: 0 };

    /* showModal peut lever une erreur (lecteur resté ouvert en mode non
       modal, élément détaché par l'éditeur) : on bascule alors sur le
       lecteur de secours plutôt que de laisser la page verrouillée. */
    var modal = false;
    if (typeof dlg.showModal === 'function') {
      try { dlg.showModal(); modal = true; } catch (err) { modal = false; }
    }
    if (!modal) {
      dlg.setAttribute('open', '');
      dlg.classList.add('is-fallback');
      document.addEventListener('keydown', piegeFallback, true);
    }
    verrouiller(true);

    charger(Math.max(0, cartes.indexOf(btn)));

    var fermerBtn = dlg.querySelector('[data-td-ugc-close]');
    if (fermerBtn) fermerBtn.focus();
  }

  document.addEventListener('click', sansEchec(function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-td-ugc-open]');
    if (!btn) return;
    e.preventDefault();
    ouvrir(btn);
  }));

  /* Éditeur de thème : un bloc re-rendu ou retiré ne laisse pas de lecteur ouvert. */
  document.addEventListener('shopify:section:unload', sansEchec(function () { if (actif) fermer(); }));
})();
